import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import {
  PUBLIC_CHROME_FIXED_LEFT_CLASS,
  PUBLIC_CHROME_INNER_BUTTON_CLASS,
  PUBLIC_CHROME_INNER_BUTTON_COMPACT_CLASS,
  PUBLIC_CHROME_SHELL_CLASS,
  PUBLIC_CHROME_SHELL_COMPACT_CLASS,
  PUBLIC_CHROME_TOGGLE_CLASS,
  PUBLIC_CHROME_TOGGLE_COMPACT_CLASS,
} from './publicChromeStyles';
import { isAppHost, isDomainSplitEnabled, landingUrl } from '../../utils/domainRouting';

function PublicBackToHomeLink({
  to = '/',
  label,
  variant = 'inline',
  compact = false,
  className = '',
}) {
  const useLandingDomain = isDomainSplitEnabled() && isAppHost();
  const destination = useLandingDomain ? landingUrl(to) : to;

  const wrapperClass =
    variant === 'fixed'
      ? `${PUBLIC_CHROME_FIXED_LEFT_CLASS} ${className}`
      : `shrink-0 ${className}`;

  const shellClass = compact ? PUBLIC_CHROME_SHELL_COMPACT_CLASS : PUBLIC_CHROME_SHELL_CLASS;
  const toggleClass = compact ? PUBLIC_CHROME_TOGGLE_COMPACT_CLASS : PUBLIC_CHROME_TOGGLE_CLASS;
  const innerClass = compact ? PUBLIC_CHROME_INNER_BUTTON_COMPACT_CLASS : PUBLIC_CHROME_INNER_BUTTON_CLASS;

  const content = (
    <>
      {!compact ? (
        <ArrowLeftIcon className="h-4 w-4 shrink-0 text-orange-500" aria-hidden />
      ) : null}
      <div className={toggleClass}>
        <span className={innerClass}>
          {compact ? (
            <ArrowLeftIcon className="h-3.5 w-3.5 shrink-0 text-orange-500" aria-hidden />
          ) : null}
          {label}
        </span>
      </div>
    </>
  );

  return (
    <div className={wrapperClass}>
      {useLandingDomain ? (
        <a href={destination} className={`group ${shellClass}`}>
          {content}
        </a>
      ) : (
        <Link to={destination} className={`group ${shellClass}`}>
          {content}
        </Link>
      )}
    </div>
  );
}

export default PublicBackToHomeLink;
